import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {CommunicationApiService} from '../../../../../Services/Api/Communication/communication-api.service';
import {CommunicationFilters} from '../../../../../Models/Communication/communication-filters.model';
import {CommunicationWidgetDto} from '../../../../../Models/Communication/communication-widget.interface';

@Component({
  selector: 'app-unread-communications-widget',
  templateUrl: './unread-communications-widget.component.html',
  styleUrls: ['./unread-communications-widget.component.scss'],
  standalone: false
})
export class UnreadCommunicationsWidgetComponent extends WidgetDataControllerComponent<CommunicationWidgetDto[]> {

  get widgetData(): CommunicationWidgetDto[] {
    return this.data ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected communicationService: CommunicationApiService,
  ) {
    super(injector, communicationService);

    this.getFakeData();
  }


  /**
   * Obtener datos falsos
   *
   */
  getFakeData() {
    this.fakeData = [
      {
        id: 239273,
        id_subtipo: 10,
        titulo: "Chat comida",
        color: "#0b9cf3",
        cerrado: false,
        comentarios: [
          {
            id: 156620,
            id_usuario: 4414,
            fecha: "1741182147000",
            fecha_formated: "hace 15 minutos",
            comentario: "Bocadillo",
            usuario: "Pablo",
            avatar: '',
            archivo: null,
          }
        ],
        not: 4,
      },
      {
        id: 249681,
        id_subtipo: 4,
        comentarios: [
          {
            id: 126620,
            id_usuario: 22244,
            fecha: "1741182147000",
            fecha_formated: "hace 2 horas",
            comentario: "Pasamos y vemos",
            usuario: "Jesus",
            avatar: '',
            archivo: null,
          }
        ],
        titulo: "Avería cafetera",
        color: "#f87f00",
        cerrado: false,
        not: 2,
      }
    ];
  }


  /**
   * Obtener las comunicaciones sin leer
   *
   */
  override setData(data: CommunicationWidgetDto[]) {
    this.data = data.filter((item) => item.not > 0);
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters: CommunicationFilters = new CommunicationFilters();
    filters.id_local = this.widgetsManager.filters?.local.id || 0;

    return this.communicationService.getCommunications(filters, false);
  }

}
